import axios from "axios";
import * as localforage from "localforage";

export const getAllAlarmPoliciesAPI = async () => {
  const companyId = await localforage.getItem("companyId");

  let response = await axios({
    url: `/api/v2/alarm/policy/options`,
    method: "GET",
    params: {
      company_id: companyId
    }
  });

  const alarmPolicesArray = response.data.alarm_policy_options;
  return alarmPolicesArray;
};
